
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 4V3a3 3 0 016 0v1h2.5c.813 0 1.5.688 1.5 1.5V9h-1V5.5c0-.25-.25-.5-.5-.5h-11c-.281 0-.5.25-.5.5V13c0 1.125.875 2 2 2h5v1H3a3 3 0 01-3-3V5.5A1.5 1.5 0 011.5 4H4zm1-1v1h4V3c0-1.094-.906-2-2-2-1.125 0-2 .906-2 2z","fill":"#212121"}}),_c('path',{attrs:{"d":"M14.5 14c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5H13v-1.5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5V13h-1.5c-.281 0-.5.25-.5.5 0 .281.219.5.5.5H12v1.5c0 .281.219.5.5.5.25 0 .5-.219.5-.5V14h1.5z","fill":"#212121"}})])
          )
        }
      }
    